class GiftPackage extends HTMLElement {
  constructor() {
    super();
    this.giftCardCheckbox = this.querySelector('#pdp_giftCard_checkbox');
    this.giftCardMain = this.querySelector('.pdp-giftCards-main');
    this.giftCardSelect = this.querySelector('.custom-giftcard-select');
    this.giftCardSelectTrigger = this.querySelector('.custom-giftcard-select__trigger');
    this.giftCardNote = this.querySelector('.pdp-giftCard-note');
    this.giftCardImage = this.querySelector('.pdp-giftCard-image img');
    this.giftCardSelectOptions = this.querySelectorAll('.custom-giftcard-custom-option');
    this.template = document.body.dataset.template;
    this.giftCardCollection = this.dataset.collection;

    this.giftCardCheckbox.addEventListener('change', this.toggleGiftCard.bind(this));
    this.giftCardSelectOptions.forEach((option) => {
      option.addEventListener('click', this.selectGiftCard.bind(this));
    });
    this.giftCardSelectTrigger.addEventListener('click', this.toggleGiftCardOptions.bind(this));

    if (this.giftCardNote) {
      this.giftCardNote.addEventListener('input', this.giftCardNoteInputHandler.bind(this));
    }
  }

  giftCardNoteInputHandler(event) {
    let cart_note = event.target.value;
    if (cart_note.length <= 100) {
      var text = this.pdpRemoveEmojis();
      localStorage.setItem('cart_note', text);
    }
  }

  pdpRemoveEmojis() {
    const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
    this.giftCardNote.addEventListener(
      'input',
      (event) => {
        this.giftCardNote.value = this.giftCardNote.value.replace(emojiRegex, '');
      },
      false,
    );
    this.giftCardNote.addEventListener(
      'paste',
      (event) => {
        this.giftCardNote.value = this.giftCardNote.value.replace(emojiRegex, '');
      },
      false,
    );
    return this.giftCardNote.value;
  }

  selectGiftCard(event) {
    const selectedOption = event.target;
    this.giftCardSelectTrigger.querySelector('span').textContent = selectedOption.textContent;
    this.giftCardSelectOptions.forEach((option) => {
      option.classList.remove('selected');
    });
    selectedOption.classList.add('selected');
    this.changeGiftCardData(selectedOption.dataset);
    this.giftCardSelectTrigger.classList.add('selected');
    this.giftCardSelect.classList.remove('open');
  }

  changeGiftCardData(data) {
    if (data.value !== 'default_value') {
      if (this.giftCardImage.getAttribute('src') !== data.imgSrc) {
        this.giftCardImage.src = data.imgSrc;
      }
      this.giftCardSelectTrigger.querySelector(`span`).setAttribute('product-id', data.productId);
    }
  }

  async checkGiftCardPackageRemove(collections) {
    if (this.template === 'product') {
      const isGiftPackageInCart = collections?.includes(this.giftCardCollection);
      if (isGiftPackageInCart) {
        this.show();
      }
    }
  }

  toggleGiftCardOptions() {
    this.giftCardSelect.classList.toggle('open');
  }

  toggleGiftCard() {
    this.giftCardMain.classList.toggle('hidden');
    if (this.giftCardCheckbox.checked) {
      this.giftCardSelectTrigger.classList.add('selected');
      if (this.giftCardSelectOptions.length > 0) {
        this.giftCardSelectOptions.forEach((option) => {
          option.classList.remove('selected');
        });
        this.giftCardSelectOptions[0].classList.add('selected');
      }
    } else {
      this.giftCardSelectTrigger.classList.remove('selected');
      this.giftCardSelectOptions.forEach((option) => {
        option.classList.remove('selected');
      });
    }
  }

  hide() {
    this.giftCardMain.classList.add('hidden');
    this.querySelector(".pdp-giftCard-banner").classList.add('hidden');
    this.giftCardSelectTrigger.classList.remove('selected');
    this.giftCardSelectOptions.forEach((option) => {
      option.classList.remove('selected');
    });
  }

  show() {
    this.querySelector(".pdp-giftCard-banner").classList.remove('hidden');
    this.giftCardCheckbox.checked = false;
  }
}
customElements.define('gift-package', GiftPackage);
